var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticClass:"container"},[_c('el-main',{staticClass:"main-content"},[_c('banner'),_c('top5'),_c('DeveloperSelection'),_c('main-content-area')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }